import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/clash-grotesk/ClashGrotesk-Light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/clash-grotesk/ClashGrotesk-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/clash-grotesk/ClashGrotesk-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/clash-grotesk/ClashGrotesk-Semibold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22variable%22:%22--font-clash-grotesk%22,%22display%22:%22swap%22,%22preload%22:true}],%22variableName%22:%22clashGrotesk%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'clashGrotesk', 'clashGrotesk Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
